// ProductOffering.jsx

import React from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import imgUrl from '../assets/images/imgUrl';
import productImage from '../assets/images/productOfferingSwiper/productDashboard.png'
import {CircleChartWithCarousel} from "./CircleChartComponent/CircleChartWithCarousal";
const products = [
  {
    title: 'Workflow based monitoring',
    description: 'Enhancing early detection and response through a unified surveillance system.',
    image: productImage,
  },
  {
    title: 'Workflow based monitoring',
    description: 'Enhancing early detection and response through a unified surveillance system.',
    image: productImage,
  },
  {
    title: 'Workflow based monitoring',
    description: 'Enhancing early detection and response through a unified surveillance system.',
    image: productImage,
  },
  // Add more products if needed
];

const ProductOffering = () => {
  return (
    <Box sx={{ px: { xs: 2, md: 8 }, py: 6 }} className="productOfferingSection" id="products">
      {/* Title */}
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        letterSpacing={2}
        gutterBottom
        className="mainHeading2"
      >
        PRODUCT OFFERING
      </Typography>

      <CircleChartWithCarousel />
    </Box>
  );
};

export default ProductOffering;
